/** 角色类型 */
export const RoleType = {
    /** 骑手 */
    rider: 'RIDER_WITHDRAW',

    /** 经纪人 */
    agent: 'BROKER_WITHDRAW',
    
    /** 小运力公司 */
    transport: 'TRANSPORT_WITHDRAW'
};

/** 审核状态 */
export const AuditState = {
    /** 新建 */
    INIT: 'INIT',

    /** 审核中 */
    AUDIT: 'AUDIT',

    /** 首次审核成功 */
    FIRST_SUCCESS: 'FIRST_SUCCESS',

    /** 首次审核失败 */
    FIRST_FAIL: 'FIRST_FAIL',

    /** 最终审核成功 */
    FINAL_SUCCESS: 'FINAL_SUCCESS',

    /** 最终审核失败 */
    FINAL_FAIL: 'FINAL_FAIL',
};

/** 付款状态 */
export const PayState = {
    /** 成功 */
    SUCCESS: 'SUCCESS',

    /** 付款失败 */
    FAILED: 'FAILED',

    /** 付款中 */
    DOING: 'DOING'
};

/** 表格操作 */
export const TableAction = {
    /** 首次审核 */
    first: 'firtst',

    /** 最终审核 */
    last: 'last',

    /** 付款 */
    pay: 'pay'
};

/** 审核通过状态 */
export const PassType = {
    /** 通过 */
    PASS_AUDIT: 'PASS_AUDIT',

    /** 不通过ƒ */
    WAIT_AUDIT: 'WAIT_AUDIT'
};

/** 默认列表字段 */
export const DefaultListFeilds = {

    /** 标识 */
    id: 'id',

    /** 手机号 */
    tel: 'phone',

    /** 姓名 */
    name: 'name',

    /** 付款金额 */
    payMoney: 'amount',

    /** 账户 */
    account: 'account',

    /** 状态 */
    state: 'status',
    stateDesc: 'statusDesc',

    /** 付款状态 */
    payState: 'payStatus',
    payStateDesc: 'payStatusDesc',

    /** 付款说明 */
    payRemark: 'remark',

    /** 新建时间 */
    createTime: 'gmtCreate'
};

/** 详情页面字段 */
export const DefaultDetailFields = {

    /** 操作 */
    operation: 'postStatusDescript',

    /** 操作备注 */
    operateRemark: 'comment',

    /** 操作人 */
    operator: 'auditUserName',

    /** 操作时间 */
    operateTime: 'gmtCreate'
};
